import { emotionTheme } from '@styles/theme'

import { CheckCircle } from '@assets/svgs/CheckCircle'
import { ProjectorScreenChart } from '@assets/svgs/ProjectorScreenChart'

import * as S from './styles'

const statusMap = {
  completed: {
    icon: <CheckCircle />,
    label: 'Distribuído',
    color: emotionTheme.colors.green[500],
    background: emotionTheme.colors.green[100]
  },
  pending: {
    icon: <ProjectorScreenChart />,
    label: 'Não distribuído',
    color: emotionTheme.colors.secondary,
    background: emotionTheme.colors.gray[300]
  }
}

export const WeekStatus = ({ status }: { status: 'completed' | 'pending' }) => {
  return (
    <S.Container>
      <S.Content
        style={{
          color: statusMap[status].color,
          background: statusMap[status].background
        }}
      >
        {statusMap[status].label}
      </S.Content>
    </S.Container>
  )
}
